export default __webpack_public_path__ + "static/media/interview01_2.7d29574d.jpg";